import { useDispatch } from "react-redux"
import { ExportButton } from "../../../../itrust_common/components/others"
import SecureFaxForm from "../../secureFax/SecureFaxForm"
import { patientReportEmail, patientReportPreview } from "../../../../redux/actions/patient/patientReportActions"
import { Field, reduxForm } from "redux-form"
import { Input } from "../../../../itrust_common/components/form"
import { email, required } from "../../../../itrust_common/components/form/FormValidations"
import { useState } from "react"
import { reportFaxLoad } from "../../../../redux/actions/reports/reportsActions"
import { API_VERSION_ONE } from "../../../../itrust_common/utils/apiUtils"

let EmailForm = props => {
  const { handleSubmit } = props;
  return (
    <form onSubmit={handleSubmit} className="d-flex w-100 align-items-start">
      <Field
        name="email"
        component={Input}
        validate={[required, email]}
        placeholder="Enter email"
        className="form-control form-control-sm"
        wrapperClasses="form-group mb-0"
      />
      <button className="btn btn-outline-primary px-1 pt-1 pb-0 rounded-0">
        <i className="la la-paper-plane"></i>
      </button>
    </form>
  );
}

EmailForm = reduxForm({
  form: 'emailPrescriptionReport',
  enableReinitialize: true,
})(EmailForm)

export default function PrescriptionActions(props) {
  const { prescription } = props
  const [showEmailForm, setShowEmailForm] = useState(false)
  const dispatch = useDispatch()
  let reportFilters = { report_type: 'prescriptions', object_id: prescription.id, prescription_without_exam: true, prescription_id: prescription.id }

  const emailPrescriptionReportSend = async (data) => {
    await dispatch(patientReportEmail(prescription.id, { ...data, ...reportFilters }))
    setShowEmailForm(false)
  }

  const onSecureFax = (data) => {
    dispatch(reportFaxLoad(prescription.id, { ...data }))
  }

  const handlePrintPrescription = async () => {
    const response = await dispatch(patientReportPreview(prescription.id, reportFilters))
    window.open(response.value.data.filepath, '_blank')
  }

  return (
    <div className="d-flex flex-row justify-content-between align-items-center mx-2 my-8 exam-form-header-btn">
      <div className="w-25">
        <SecureFaxForm onSubmit={onSecureFax} />
      </div>
      <div className="d-flex align-items-center">
        <div className="position-relative d-flex">
          {showEmailForm && <div className="position-absolute width-16 mt-2 mr-5 d-flex" style={{ right: '4rem' }}>
            <EmailForm
              onSubmit={emailPrescriptionReportSend}
              initialValues={{ email: prescription.patient_attributes.email, ...reportFilters }}
            />
          </div>}
          {showEmailForm ?
            <button type="button" className="btn btn-outline-danger ml-6" onClick={() => setShowEmailForm(false)}>Cancel</button> :
            <button type="button" className="btn btn-outline-primary ml-6" onClick={() => setShowEmailForm(true)}>Send Email</button>
          }
        </div>
        <button type="button" className="btn btn-outline-primary ml-6" onClick={handlePrintPrescription}>Print</button>
        <ExportButton
          label="Download"
          className="btn btn-outline-primary ml-6"
          path={`/${API_VERSION_ONE}/reports/${prescription.id}/download`}
          params={reportFilters}
        />
      </div>
    </div>
  )
}
